/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';

export const useRemoveBenefitFromEmployee = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((benefitId: string) => Promise.resolve({ benefitId }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['employee/benefits']);
    },
    onError: () => {
      AlertAdapter('Failed to delete', 'error');
    },
  });
  return mutation;
};
